var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-input"},[(_vm.loading)?_c('v-progress-linear',{staticStyle:{"top":"-16px"},attrs:{"absolute":"","height":"2","indeterminate":""}}):_vm._e(),_c('div',_vm._g({ref:"editable",staticClass:"text",class:{ disabledInput: _vm.disabledInput, empty: _vm.isEmpty },style:({
      color: _vm.$vuetify.theme.currentTheme.text,
      backgroundColor: 'transparent !important',
    }),attrs:{"contenteditable":!_vm.disabledInput}},_vm.listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }